module.exports = __webpack_public_path__ + "img/3-3-1.8c26253d.svg";